import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { BerekendClass } from '@/domain/interface/BerekendClass';

@Module({namespaced: true})
export default class Berekend extends VuexModule {
  public berekend: BerekendClass = new BerekendClass();

  @Mutation
  public setBerekend(berekend: BerekendClass): void {
    this.berekend = berekend;
  }

  @Action
  public updateBerekend(berekend: BerekendClass): void {
    this.context.commit('setBerekend', berekend);
  }

  @Action
  public resetBerekend(): void {
    this.context.commit('setBerekend', false);
  }

  get getBerekend(): BerekendClass {
    return this.berekend;
  }
}